export default {
  userInfo: {},
  clauses: [],
  accessToken: "",
};
